import React from "react";
import Head from "next/head";
import BusinessBanner from "../../components/Banner/Business";
import MarketOperate from "~/components/MarketOperate/Business";
import Footer from "~/components/Footer";
import DepoCarousel from "~/components/DepoCarousel";
import ServiceOffer from "~/components/MarketOperate/Business/ServiceOffer";
import Partners from "~/components/Partners";
import BusinessInformation from "~/components/BusinessInformation";
import "bootstrap/dist/css/bootstrap.min.css";

const Business = () => {
    return (
        <>
            <Head>
                <title>Fotógrafo profissional para sua empresa - Fotop Serviços Business</title>
                <link rel="stylesheet" type="text/css" href="/css/outside.css" />
            </Head>

            <BusinessBanner />
            <BusinessInformation />
            <Partners />
            <MarketOperate />
            <ServiceOffer />
            <DepoCarousel />
            <Footer />
        </>
    );
};

export default Business;
